"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const getDlsV5Value_1 = __importDefault(require("./getDlsV5Value"));
function getDlsValue(par, target, vals, suspensions = []) {
    (0, getDlsV5Value_1.default)(par, target, vals, suspensions);
}
exports.default = getDlsValue;
//# sourceMappingURL=getDlsValue.js.map